import { fetchSendValidationCode, EType } from '../repositories/sms/v2/send-validation-code';
export function sendValidationCode(httpApi, phone) {
  return fetchSendValidationCode({
    httpApi: httpApi,
    parameters: {
      phone: phone,
      type: EType.AuthenticateCode
    },
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']]
      }
    }
  });
}